import { render } from "./UpdateProduction.vue?vue&type=template&id=466368b8"
import script from "./UpdateProduction.vue?vue&type=script&lang=js"
export * from "./UpdateProduction.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__